import { api } from "./api";

export async function getViewerSession() {
  let authError = null;
  try {
    const { data } = await api.get("/auth/me");
    if (data?.authenticated) {
      return { session: data, source: "auth", error: "" };
    }
  } catch (err) {
    authError = err;
  }

  try {
    const { data } = await api.get("/viewer/me");
    if (data?.authenticated && data.viewer) {
      return {
        session: {
          authenticated: true,
          twitch_user_id: data.viewer.twitch_user_id,
          login: data.viewer.login,
          display_name: data.viewer.display_name || data.viewer.login,
          profile_image_url: data.viewer.profile_image_url,
          role: "viewer",
        },
        source: "viewer",
        error: "",
      };
    }
  } catch (err) {
    if (authError) {
      return { session: null, source: "", error: "The account service could not be reached." };
    }
  }

  return { session: null, source: "", error: authError ? "The account service could not be reached." : "" };
}
